import React from 'react';

import {CONFIG} from '../constants'

interface MarkerInterface {
  lat: number,
  lng: number,
}

interface ComponentProps {
  markers: Array<MarkerInterface>;
  width: number;
  height: number;
  classes: string;
  small?: boolean;
}

interface ComponentState {
  mapUrl: string
}

export default class GoogleMapImage extends React.Component<ComponentProps, ComponentState>  {

  state = {
    mapUrl: ''
  }

  componentDidMount() {
 
    let mapUrl = '';
    for (const marker of this.props.markers) {
      mapUrl = CONFIG.API_ENDPOINT + `static_map?w=${this.props.width}&h=${this.props.height}&lat=${marker.lat}&lng=${marker.lng}&callback=${Function.prototype}`    }
    this.setState({ mapUrl: mapUrl })
  }

  render() {
    const iWidth = this.props.width + 'px';
    const iHeight = this.props.height + 'px';
    return (
      <img alt="map" className={this.props.classes} src={this.state.mapUrl} style={{width: iWidth, height: iHeight}}/>
    )
  }

}
